import { SpacePickerHelpers } from "@swivl-mono/helpers";
import {
  ActionTakenType,
  FacilityAndSpaceFeatures,
  SpaceInterface,
  SpacePickerParams,
  SpaceTags,
  UnitInterface,
  createActionTaken
} from "@swivl-mono/types";
import { Slide } from "pure-react-carousel";
import { useCallback } from "react";
import React from "react";

import { Config } from "../../../../../Config/Config";
import { SwivlChat } from "../../../../../SwivlChat";
import { LanguageContext, t } from "../../../../../i18n/strings";
import { MessageHandlerInterface } from "../../../../../messages/MessageHandler";
import { ListItemData } from "../../../ListItem";

interface SpaceCardProps {
  index: number;
  item: ListItemData;
  space: UnitInterface;
  messageHandler: MessageHandlerInterface;
  delegate: SwivlChat;
  params: SpacePickerParams;
  filterDisplayNames: { [key: string]: string };
  currenySymbol?: string;
}

export const SpaceCard = (props: SpaceCardProps) => {
  const language = React.useContext(LanguageContext);
  const [startX, setStartX] = React.useState(0);

  const mouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
    setStartX(e.clientX);
  };
  const spaceSelected = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      if (!Config.canPressButtons) {
        return;
      }
      if (e.clientX && startX && Math.abs(e.clientX - startX) > 5) {
        // This checks to make sure we weren't dragging.
        return;
      }
      const messageId = props.item.message.uuid;
      const actionTaken = createActionTaken(ActionTakenType.Selected, props.item.id, props.space);

      props.messageHandler.actionTaken(messageId, actionTaken);
      // this.setState({selectTwo:true});
    },
    [startX]
  );

  const { index, space, params, filterDisplayNames, currenySymbol } = props;
  const { imageURL, text } = SpacePickerHelpers.imageAndTextURLForSpace(space, params);
  const floor = space.floor && space.floor > 0 ? space.floor : 1;
  let features: string[] = [];
  if (props.params.showFloor) {
    if (!space?.features.includes(FacilityAndSpaceFeatures.UpperLevel)) {
      features.push(t("inventoryPickerFloor", language) + " " + floor);
    }
  }
  // const featuresToShow = [
  //   FacilityAndSpaceFeatures.ClimateControl ,
  //   FacilityAndSpaceFeatures.FirstFloor ,
  //   FacilityAndSpaceFeatures.Unpaved ,
  //   FacilityAndSpaceFeatures.Paved ,
  //   FacilityAndSpaceFeatures.Covered,
  //   FacilityAndSpaceFeatures.PullThru ,
  //   FacilityAndSpaceFeatures.Heated,
  //   FacilityAndSpaceFeatures.UpperLevel,
  //   FacilityAndSpaceFeatures.Inside,
  //   FacilityAndSpaceFeatures.DriveUp,
  //   FacilityAndSpaceFeatures.Elevators,
  //   FacilityAndSpaceFeatures.Alarm,
  //   FacilityAndSpaceFeatures.Power
  // ]

  SpaceTags.forEach((tag) => {
    if (space.features?.includes(tag as FacilityAndSpaceFeatures)) {
      // if (featuresToShow.includes(tag as FacilityAndSpaceFeatures)) {
      features.push(filterDisplayNames[tag] || tag);
      // }
    }
  });

  // if (space.isParking) { features.push(SpaceFeatureName.IsParking); }
  // if (space.hasClimateControl) { features.push(SpaceFeatureName.ClimateControl); }
  // if (space.isInside) { features.push(SpaceFeatureName.Indoor); }
  // if (space.hasPower) { features.push(SpaceFeatureName.Power); }
  // if (space.hasAlarm) { features.push(SpaceFeatureName.Alarm); }
  // if (space.isDriveUp) { features.push(SpaceFeatureName.DriveUp); }
  // if (space.hasElevatorAccess) { features.push(SpaceFeatureName.ElevatorAccess); }
  // if (space.isUpperLevel) { features.push(SpaceFeatureName.UpperLevel); }

  // const text = 'About the size of an average small bedroom or half of a one-car garage. Plenty of room for 10 boxes, a bed frame, shelves, a desk chair and something else.'
  return (
    <Slide index={index} key={"slide_" + index} innerClassName="scc-spaceSlide">
      <div className="scc-spaceImage">
        <div className="scc-spaceImageBackground" style={{ background: Config.primaryButtonBackground }} />
        <img src={imageURL} />
      </div>
      <div className="scc-spaceSizeAndPrice">
        <div className="scc-spaceSize">{space.dimensions}</div>
        {params.showPrice ? (
          <div className="scc-spacePrice">
            {t("inventoryPickerFrom", language)} {currenySymbol || "$"}
            {space.rate ? space.rate.toFixed(2) : "0"}
          </div>
        ) : null}
      </div>
      <div className="scc-spaceFeature">
        {features.map((i) => (
          <div key={i} className="scc-spacePill">
            <div className="scc-spacePillBackground" style={{ background: Config.primaryButtonBackground }}></div>
            <span>{filterDisplayNames[i] || i}</span>
          </div>
        ))}
      </div>

      <div className="scc-spaceDescription">{text}</div>
      <div className="scc-spaceCTA swivl-primaryButton" onMouseDown={mouseDown} onMouseUp={spaceSelected}>
        {params.actionButton}
      </div>
    </Slide>
  );
};
